import { ContactBanner } from "./Banner";
import { JoinUs } from "./JoinUs";

export const Contact = () => <>
    <ContactBanner />
    <JoinUs />
</>